import Vue from 'vue';
import * as types from './mutation-types';
import http from '@service/http';

//全局Actions
export const updateUserAttrId = ({ commit }, userAttrId) => {
    commit(types.UPDATE_USER_ATTR_ID, userAttrId);
}

//初始化大区价格
export const initPriceMain = ({commit},priceMain) => {
  return http.post({
    fn: 'mallsale.goodsHandler.initPriceMain',
    param: priceMain
  }).then(result => {
    if(result && result.success && result.target && result.target.success){
        return Promise.resolve(result.target.target);
      }else{
        return Promise.reject((result && (result.message || result.target.message)) || '获取数据失败');
      }
  }).catch(error => {
    return Promise.reject(error);
  })
}


//获取客服链接
export const getCustomerLink = ({ commit }, storeId) => {
	return http.post({
		fn: 'mallsale.storeHandler.getStoreCustomerService',
		param: [storeId]
	}).then(result => {
		if(result && result.success && result.target && result.target.success){
        let linkType = result.target.target;
        let link = null;
        switch(linkType){
          case 'QTxWWKm'://美心元素
            link = 'http://p.qiao.baidu.com/cps/chat?siteId=11297261&userId=24628015';
            break;
          case 'oX5WWKm':
            /*return '美心偙朗';*/
            link = 'http://p.qiao.baidu.com/cps/chat?siteId=11296769&userId=24628015';
            break;
          case 'ZP1iAXm':
            /*return '美心工艺门';*/
            link = 'http://p.qiao.baidu.com/cps/chat?siteId=11297221&userId=24628015';
            break;
          case 'KtY2V1m':
            /*return '美心家美';*/
            link = 'http://p.qiao.baidu.com/cps/chat?siteId=11296759&userId=24628015';
            break;
          case 'PBnKL1m':
            /*return '美心蒙迪';*/
            link = 'http://p.qiao.baidu.com/cps/chat?siteId=11297232&userId=24628015';
            break;
          case '917699162'://萨瓦尼
            link = 'http://p.qiao.baidu.com/cps/chat?siteId=11297262&userId=24628015';
            break;
          case '3114195734'://美心智远
            link = 'http://p.qiao.baidu.com/cps/chat?siteId=11297263&userId=24628015';
            break;
          default:
            /*return '市场部';*/
            link = 'http://p.qiao.baidu.com/cps/chat?siteId=11296598&userId=24628015';
            break;

        }
        
        commit(types.CUSTOMER_SHREF,"http://p.qiao.baidu.com/cps/chat?siteId=11373955&userId=24698474");
        return Promise.resolve(result.target.target);
      }else{
        return Promise.reject((result && (result.message || result.target.message)) || '获取数据失败');
      }
	}).catch(error => {
		return Promise.reject(error);
	})
}


// WEBPACK FOOTER //
// ./src/store/actions.js